import { BreakEmaLine } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setups/BreakEmaLine';
import { BreakEmaTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/setups/BreakEmaTacticPanel';
import BreakEmaWrapper from '../../../../components/displays/tradeplans/softOrderModules/setupModules/BreakEmaModule/wrapper/BreakEmaWrapper';
import BreakEmaDoc from '../../../../components/forms/tradeplans/documentation/BreakEmaDocumentation';
import { BreakEmaData } from './breakEmaData';
import { validateBreakEma } from './validateBreakEma';

export const BreakEma = {
  //data class
  dataStore: BreakEmaData,

  //string constants
  name: 'BREAK_EMA',
  tacticLabel: 'Break EMA',
  addTacticLabel: 'Add Break EMA',
  category: 'Setup',

  //components
  tradePlanFormModule: null,
  tacticPanel: BreakEmaTacticPanel,
  addTacticPanel: null,
  wrapper: BreakEmaWrapper,
  chartSoftOrderComponent: BreakEmaLine,
  documentation: BreakEmaDoc,
  alertDetailsComponent: null, //todo

  //functions
  setupDetailParser: null, //todo
  validationFunction: validateBreakEma,
};
